export default {
    GET_IS_SYNC_DATA_TO_BROWSER_STORAGE : '[SETTING] GET_IS_SYNC_DATA_TO_BROWSER_STORAGE',
    // Config
    CONFIG_XML_PATH_PERFORMANCE_POS_DEFAULT_MODE: 'webpos/performance/pos_default_mode',
    CONFIG_XML_PATH_PERFORMANCE_POS_TABLET_DEFAULT_MODE: 'webpos/performance/pos_tablet_default_mode',
}



// WEBPACK FOOTER //
// ./src/view/constant/settings/GeneralConstant.js